import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";

import Select from "../../UI/CustomSelect/CustomSelect";
import * as actionCreators from "../../../Store/actions/index";
import classes from "./MainToolBar.module.css";
import logo from "../../../assets/svg/pcariMainToolBarLogo.svg";
import SearchIcon from "../../../assets/svg/SearchIcon.svg";
import IconHeart from "../../../assets/svg/IconHeart.svg";
import IconUser from "../../../assets/svg/IconUser.svg";
import message from "../../../assets/svg/message.svg";


const MainToolBar = (props) => {
    const [showSelect, setShowSelect] = useState(false);
    const callSetShowSelect = () => {
        setShowSelect(!showSelect)
    }
    return (
        <div className={classes.MainToolBar}>
            <NavLink to='/'>
                <img src={logo} alt='' style={{ margin: '.2rem .4% .2rem 0' }} onClick={() => {
                    props.onChangeVehicleType('all');
                    localStorage.setItem('vehicleType', 'all');
                }} />
            </NavLink>
            <div className={classes.Search}>
                <form onSubmit={event => {
                    event.preventDefault();
                    props.props.history.push(`/Search?find=${props.searchInputValue}`)
                    props.reLoadSearchPage()
                }}>
                    <input
                        type="search"
                        placeholder="Search Any Vehicle"
                        value={props.searchInputValue}
                        onChange={event => {
                            props.searchInput(event.target.value);
                        }} />
                    <select className={classes.onlyMediumScreen} onChange={event => {
                        props.onChangeVehicleType(event.target.value)
                    }}>
                        <option value='all'>Vehicle Type</option>
                        <option value='cars'>cars</option>
                        <option value='motors'>motors</option>
                        <option value='commercials'>commercials</option>
                        <option value='accessories'>accessories</option>
                    </select>
                    <button type="submit">
                        <img src={SearchIcon} alt='Search' />
                    </button>
                </form>
            </div>
            {props.userEmail ?
                <div className={classes.AuthUserNavLink}>
                    <div
                        className={classes.IconLink}
                        onClick={() => {
                            props.props.history.push('/Messages')
                            //    window.location.reload(false)
                        }}>
                        <img src={message} alt='IconMessage' width='25px' />
                    </div>
                    <div
                        className={classes.IconLink}
                        onClick={() => {
                            props.props.history.push('/WishList')
                            //    window.location.reload(false)
                        }}>
                        <img src={IconHeart} alt='IconHeart' />
                    </div>
                    <div
                        className={`${classes.IconLink} ${classes.onlyLargeScreen}`}
                        onClick={event => { callSetShowSelect() }}><img src={IconUser}
                            alt='IconUser' />
                    </div>
                    <div>
                        <Select
                            show={showSelect}
                            logoutUser={props.onLogoutAuth}
                            routeProp={props.props}
                            currentUser={props.currentUser}
                            setShowSelect={setShowSelect}
                            list={[
                                { name: 'logout' },
                                { name: 'profile' }
                            ]} />
                    </div>
                </div>
                :
                <div className={`${classes.GuestUserNavLink} ${classes.onlyLargeScreen}`}>
                    <a
                        href='/'
                        onClick={event => {
                            event.preventDefault()
                            props.showAuthHandler('signIn')
                        }}
                    >Sign in<span className={classes.onlyLargeScreen}> / join</span></a>
                    <a
                        href='/'
                        onClick={event => {
                            event.preventDefault()
                            props.showAuthHandler('signUp')
                        }}
                    >Sign up</a>
                </div>}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        loading: state.wishListLoading,
        userEmail: state.Auth.userEmail,
        currentUser: state.Auth.currentUser
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGetVehilveItems: (type, search) => { dispatch(actionCreators.getVehicleItems(type, 1, search)) },
        onChangeVehicleType: (type) => { dispatch(actionCreators.changeVehicleType(type)) },
        onLogoutAuth: () => { dispatch(actionCreators.logoutAuth()) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainToolBar);